export function mulberry32(a) {
    return function() {
      let t = a += 0x6D2B79F5;
      t = Math.imul(t ^ t >>> 15, t | 1);
      t ^= t + Math.imul(t ^ t >>> 7, t | 61);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
}



/**
 * Mulberry32 is a tiny, high-quality 32-bit PRNG.
 * It's perfect for procedural generation where speed and 
 * consistent distribution are key.
 */
export const getMulberry32 = (seed) => {
    return function() {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
};

/**
 * Creates a unique seed for a coordinate pair.
 * Ensures that (1,2) and (2,1) have different seeds.
 */
export function getCoordSeed(x, y, worldSeed) {
    const str = `${x}_${y}_${worldSeed}`;
    let hash = 2166136261 >>> 0;
    for (let i = 0; i < str.length; i++) {
        hash = Math.imul(hash ^ str.charCodeAt(i), 16777619);
    }
    return hash >>> 0;
}

export function getSeedHash(seed) {
    let hash = 2166136261 >>> 0;
    for (let i = 0; i < seed.length; i++) {
        hash = Math.imul(hash ^ seed.charCodeAt(i), 16777619);
    }
    return hash >>> 0;
}

export function getTileSeed(x, y, worldSeed, offset) {
    const str = `${x}_${y}_${worldSeed}_${offset}`;
    let hash = 2166136261 >>> 0;
    for (let i = 0; i < str.length; i++) {
        hash = Math.imul(hash ^ str.charCodeAt(i), 16777619);
    }
    return hash >>> 0;
}